module.exports = __webpack_public_path__ + "img/720.9251100d.svg";